import type { Optional } from '@festina-life/core'

import type { ComparableField } from '../../../types/diffing'
import {
  isConfigurationFunction,
  isSubTemplatedFieldValue,
  isTemplateField,
  isTemplateVersion,
} from '../../../types/templateModel'
import { isSpecialCasedSubTemplatedValueSetup } from '../../specialCasedSubTemplatedViewers/types'
import { SpecialCasedSubTemplatedFieldValueContent } from './SpecialCasedSubTemplatedFieldValueContent'
import { SubTemplatedFieldValueContent } from './SubTemplatedFieldValueContent'
import { TemplateFieldContent } from './TemplateFieldContent'
import { TemplateFunctionContent } from './TemplateFunctionContent'
import { TemplateVersionContent } from './TemplateVersionContent'

type Props = {
  data: Optional<ComparableField>
}

export const TemplateDetailsContentSelector = ({ data }: Props) => {
  if (!data) {
    return null
  }

  if (isSpecialCasedSubTemplatedValueSetup(data)) {
    return <SpecialCasedSubTemplatedFieldValueContent data={data} />
  }

  if (isConfigurationFunction(data)) {
    return <TemplateFunctionContent data={data} />
  } else if (isTemplateField(data)) {
    return <TemplateFieldContent field={data} />
  } else if (isTemplateVersion(data)) {
    return <TemplateVersionContent templateVersion={data} isExpanded />
  } else if (isSubTemplatedFieldValue(data)) {
    return <SubTemplatedFieldValueContent variant={data} />
  } else {
    throw new Error('Unsupported field type.')
  }
}
